export const Error404 = () => {
    return <div>Error 404</div>;
};
